import { RAW_MATERIAL_RETURN_CHALLAN_REQUEST, CREATE_RAW_MATERIAL_RETURN_CHALLAN, GET_RAW_MATERIAL_RETURN_CHALLANS, UPDATE_RAW_MATERIAL_RETURN_CHALLAN, 
  DELETE_RAW_MATERIAL_RETURN_CHALLAN, RAW_MATERIAL_RETURN_CHALLAN_REQUEST_FAILURE } from '../types';

const initialState = {
  rawMaterialReturnChallans: [],
  loading: false,
  error: null,
};

const rawMaterialReturnChallanReducer = (state = initialState, action) => {
  switch (action.type) {
    case RAW_MATERIAL_RETURN_CHALLAN_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_RAW_MATERIAL_RETURN_CHALLANS: {
      return {
        ...state,
        rawMaterialReturnChallans: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_RAW_MATERIAL_RETURN_CHALLAN:
      return {
        ...state,
        rawMaterialReturnChallans: [action.payload, ...state.rawMaterialReturnChallans],
        loading: false,
        error: null
      };
    case UPDATE_RAW_MATERIAL_RETURN_CHALLAN:
      const rawMaterialReturnChallansData = state.rawMaterialReturnChallans.slice(0);
      const uIndex = rawMaterialReturnChallansData.findIndex((data) => data.id === action.payload.id);
      rawMaterialReturnChallansData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        rawMaterialReturnChallans: [ ...rawMaterialReturnChallansData ],
        loading: false,
        error: null
      };
    case DELETE_RAW_MATERIAL_RETURN_CHALLAN:
      const rawMaterialReturnChallans = state.rawMaterialReturnChallans?.slice(0);
      const index = rawMaterialReturnChallans.findIndex((data) => data.id === action.id);
      if (index > -1) {
        rawMaterialReturnChallans.splice(index, 1);
      }
      return {
        ...state,
        rawMaterialReturnChallans: [...rawMaterialReturnChallans],
        loading: false,
        error: null
      }
    case RAW_MATERIAL_RETURN_CHALLAN_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default rawMaterialReturnChallanReducer;
